module.exports = __webpack_public_path__ + "img/enlarge.329d4bdd.svg";